import {defineStore} from "pinia";

export const useAppStore = defineStore('app', {
  state: () => ({
    showTabBar: false,
    tabBarActive: 0 as number,
    copyRightBottom: '14px',
    zIndex: -1111
  }),
  getters: {},
  actions: {
    setShowTabBar(value: boolean) {
      this.showTabBar = value
      this.setCopyRightBottom()
    },
    setTabActive(index: number) {
      this.tabBarActive = index
    },
    setCopyRightBottom(value?: string, zIndex: number = -1111) {
      if (value) {
        this.copyRightBottom = value
        this.zIndex = zIndex
        return
      }
      const tabBar = document.querySelector('.van-tabbar')
      if (this.showTabBar && tabBar) {
        this.copyRightBottom = `${tabBar.clientHeight + 10}px`
        return
      }
      this.copyRightBottom = '14px'
    }
  },
})

